import { inject, Injectable, signal } from '@angular/core';
import { SessionService } from '../../core/services/session.service';
import { finalize, map, Observable, tap } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { SKIP_ERROR_HANDLER, SHOW_LOADER, LOADER_SECTION } from '../../core/auth-context';
import { environment } from '../../../environments/environment';
import { BaseRequest } from '../../shared/models/base-request.model';
import { TradingApiService } from '../../core/services/api/trading-api.service';
import { mapToGetShoppingCartsRequestDto } from '../_domain/mappers/mappers';
import { TradingDomainService } from '../_domain/trading-domain.service';

const apiUrl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class ShopCartsService {

  private http = inject(HttpClient);
  private sessionService = inject(SessionService);
  private tradingApiService = inject(TradingApiService);
  private tradingDomainService = inject(TradingDomainService);

  carts = signal<any[]>([]);

  refreshShopCarts() {

    const request: BaseRequest = {
      params: {
        userId: this.sessionService.user().id
      },
      showLoader: true,
      loaderSection: 'shopCarts'
    };

    this.tradingDomainService.getShopCarts(request).subscribe((res: any) => {

      const resCarts = (res?.data?.shoppingCarts || []).map((o: any) => {
        return {
          ...o.header,
          creationDate: new Date(o.header.creationDate + ' UTC'),
          items: o.items
        }
      }); 

      this.carts.set(resCarts);
    });
  }

  addShopCartItem(request: BaseRequest) {

    return this.tradingDomainService.addShopCartItem(request).pipe(
      finalize(() => this.refreshShopCarts())
    );
  }

  deleteShopCart(id: string) {

    const request: BaseRequest = {
      params: {
        shoppingCartIds: [id]
      },
      showLoader: true,
      loaderSection: 'shopCarts'
    };

    return this.tradingDomainService.deleteShopCart(request).pipe(
      finalize(() => this.refreshShopCarts())
    );
  }

  deleteShopCartItem(shopCartId: string, shopCartItemId: string) {

    const request: BaseRequest = {
      params: {
        shopCartId: shopCartId,
        shopCartItemId: shopCartItemId
      },
      showLoader: true,
      loaderSection: 'shopCarts'
    };

    return this.tradingDomainService.deleteShopCartItem(request).pipe(
      finalize(() => {
        this.refreshShopCarts();
      })
    );
  }

  checkoutShopCart(id: string, showLoader: boolean = true, loaderSection: string|undefined = undefined) {

    const request: BaseRequest = {
      params: {
        id: id
      },
      showLoader: showLoader,
      loaderSection: loaderSection
    };

    return this.tradingDomainService.checkoutShopCart(request).pipe(
      finalize(() => {
        this.refreshShopCarts();
      })
    );
  }

  setShopCartExpiration(shopCart: any) {

    const request: BaseRequest = {
      params: {
        shopCart: {
          id: shopCart.id,
          expired: true
        }
      }
    };

    return this.tradingDomainService.addShopCartItem(request).pipe(
      finalize(() => this.refreshShopCarts())
    );
  }
}
